import { FC } from 'react';
import { FaEyeSlash } from 'react-icons/fa';

import { useDemoMode } from '@/util/demo-mode';

interface AdminBannerProps {
  published: boolean;
}

export const AdminBanner: FC<AdminBannerProps> = ({ published }) => {
  const { adminFeaturesEnabled } = useDemoMode();
  if (!adminFeaturesEnabled) {
    return null;
  }
  if (!published) {
    return (
      <div className={`flex justify-end w-full bg-day-light-4`}>
        <div className="mr-4 mt-2 flex">
          <p className="mr-2 text-day-neutral-dark/50 2xl:text-base text-sm">Not public</p>
          <div className="text-day-neutral-dark/50">
            <FaEyeSlash size={24} />
          </div>
        </div>
      </div>
    );
  }
};
